import React, { useEffect, useState } from "react";
import styles from "./BlogsPage.scss";
import SiteContainer from "components/homepage/SiteContainer";
import * as BlogActions from "actions/BlogActions";
import { map, orderBy } from "lodash";
import { connect } from "react-redux";
import getStaticFile from "utils/getStaticFile";

const SEARCH_ICON = getStaticFile("img/search_icon.svg");
const PLAY_ICON = getStaticFile("img/play-icon.webp");

function VideoCard({ video }) {
    const onClickRedirect = () => {
        window.location.href = `/blog/${encodeURIComponent(video.slug)}`;
    };

    return (
        <div className={`${styles.card}`} onClick={onClickRedirect}>
            <div className={styles.mainImage}>
                {video.premium && <span className={styles.premium}><i className="fa fa-star" style={{ marginRight: 2 }} />Premium</span>}
                <img src={video.socialShareImage?.file} alt={`${video.title} session logo`} />
            </div>
            {/* <span className={styles.durationTime}>15:34</span> */}
            <img src={PLAY_ICON} alt="play icon" className={styles.playImage} />
            <div className={styles.infoBox}>
                <h3>{video.title}</h3>
                <h4>{video.subtitle}</h4>
            </div>
        </div>
    );
}

function BlogsPage(props) {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredBlogs, setFilteredBlogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const itemsPerPage = 8;

    useEffect(() => {
        props.loadBlogPages();
    }, []);

    useEffect(() => {
        const term = searchTerm.toLowerCase();
        const filtered = map(props.blogPages, blog => {
            if (blog.published && (blog.title.toLowerCase().includes(term) || blog.body.toLowerCase().includes(term))) {
                return blog;
            }
            return null;
        }).filter(blog => blog !== null);
        setFilteredBlogs(filtered);
        setCurrentPage(1);
        
        
        if (props.blogPages && Object.keys(props.blogPages).length > 0) {
            setIsLoading(false);
        }
    }, [searchTerm, props.blogPages]);

    const searchVideoBlog = (evt) => {
        setSearchTerm(evt.target.value);
    };

    const totalItems = filteredBlogs.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedBlogs = filteredBlogs.slice(startIndex, startIndex + itemsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const LoadingMessage = () => {
        return (
            <div className={`container ${styles.root}`}>
                <div style={{ textAlign: 'center', padding: '3em 0' }}>
                    <h2>Loading The Jazz Vault . . .</h2>
                    <div className={styles.loadingBar}>
                        <div className={styles.loadingProgress}></div>
                    </div>
                </div>
            </div>
        )
    };

    const NoResults = () => {
        return (
            <div className={`container ${styles.root}`}>
                <h2 style={{ textAlign: 'center' }}>No videos to show</h2>
            </div>
        )
    };

   
    if (isLoading) {
        return (
            <SiteContainer minimal>
                <LoadingMessage />
            </SiteContainer>
        )
    }

   
    if (paginatedBlogs.length === 0 && !searchTerm) {
        return (
            <SiteContainer minimal>
                <NoResults />
            </SiteContainer>
        )
    }

    const renderIntroText = () => {
        if (currentPage === 1) {
            return (
                <div className={styles.introText}>
                    <p><strong>Step inside The Jazz Vault — your gateway to over 50 hours of inspiring jazz education from world-renowned teacher Jeff Antoniuk, founder of JazzWire.net.</strong></p>
                    <p><strong>If you've ever felt stuck</strong> in your solos or unsure what to practice next, The Jazz Vault gives you the clarity and confidence you've been looking for. Jeff has helped thousands of adult jazz players unlock their creativity and sound more like the musicians they admire. Now, his most insightful lessons are organized in one powerful, searchable space.</p>
                    <p><strong>This isn't just a video library</strong> — it's a curated collection of ideas, exercises, and breakthroughs designed to help you play better today. Each concept is distilled into clear, actionable steps you can apply immediately to your practice and performance.</p>
                    <p><strong>Explore 200 in-depth videos,</strong> each paired with a companion blog post and downloadable PDF. Browse by topic, tune, or challenge — and discover exactly what you need to take your next step as an improviser.</p>
                    <p><strong>Dive in,</strong> get inspired, and start unlocking your next level as a jazz musician.</p>
                    <p><strong>Love what you find?</strong> Share The Jazz Vault with your friends, bandmates, and students — it's free, and built to help our whole community grow.</p>
                </div>
            );
        } else {
            return (
                <div className={styles.introText}>
                    <h2 className={styles.subHeadline}>Step Inside The Jazz Vault — Your Library of Jazz Wisdom Awaits</h2>
                    <p><strong>Love what you're finding here?</strong> Bookmark The Jazz Vault, share it with your musician friends, and come back often — new insights are always waiting. And when you're ready to go deeper, join us at <a href="https://www.jazzwire.net/" target="_blank" rel="noopener noreferrer">JazzWire.net</a> to connect, learn, and grow with players just like you.</p>
                </div>
            );
        }
    };

    return (
        <SiteContainer minimal>
            <div className={`container ${styles.root}`}>
                <header className={styles.header}>
                    {currentPage === 1 && <h1>The Jazz Vault: Your All-Access Pass to Better Jazz Playing</h1>}
                    {renderIntroText()}
                    <hr />
                    <section className={styles.searchSection}>
                        <input type="text" name="Search" id="search" style={{ backgroundImage: `url(${SEARCH_ICON})` }} placeholder="Search for a video" onChange={searchVideoBlog} />
                    </section>
                </header>
                <section className={styles.newVideos}>
                    <h2>{(searchTerm && paginatedBlogs.length === 0) ? 'No videos to show' : 'New Videos'}</h2>
                    <div className={styles.videoGrid}>
                        {map(orderBy(paginatedBlogs, ["created"], ["desc"]), blog => (
                            <VideoCard key={blog.id} video={blog} />
                        ))}
                    </div>
                </section>
                <div className={styles.pagination}>
                    {
                        paginatedBlogs.length > 0 && (
                            <>
                                <p onClick={() => handlePageChange(currentPage - 1)}>&#10216;</p>
                                {map(Array(totalPages).fill(), (_, index) => (
                                    <span
                                        key={index}
                                        className={currentPage === index + 1 ? styles.active : ""}
                                        onClick={() => handlePageChange(index + 1)}
                                    >
                                        {index + 1}
                                    </span>
                                ))}
                                <p onClick={() => handlePageChange(currentPage + 1)}>&#10217;</p>
                            </>
                        )
                    }
                </div>
            </div>
        </SiteContainer>
    );
}

BlogsPage.propTypes = {};

export default connect(
    (state, ownProps) => {
        return {
            blogPages: state.entities.blogPages,
        }
    },
    (dispatch) => ({
        loadBlogPages: () => dispatch(BlogActions.loadBlogPages()),
    })
)(BlogsPage);
